import TrilogyHub from "./TrilogyHub";

export default function TrilogyMalo() {
  return (
    <TrilogyHub
      slug="malo"
      subtitle="Trilogie maritime historique"
      title="Malo — la trilogie"
      metaTitle="Malo — trilogie maritime historique de Bruno Courtin"
      metaDescription="Malo, une trilogie maritime de Bruno Courtin (1540-1541) : trois romans historiques qui suivent une jeune femme travestie sur La Vigilante — des côtes de Saint-Malo à l'océan Indien, jusqu'aux rivages du Japon."
      coverUrl="/api/files/malo-cover.png"
      tomeSlugs={[
        "malo-les-routes-secretes-de-locean-indien",
        "malo-la-route-de-lest",
        "malo-la-route-du-soleil-levant",
      ]}
      otherNovels={[
        "terra-australis",
        "mauritia-le-peuple-de-l-eau",
        "larbre-qui-cachait-la-foret",
        "le-feu-interieur",
        "elle",
      ]}
      intro={
        <>
          <p>
            La trilogie Malo ouvre en 1540, à Saint-Malo. Une jeune femme rousse embarque sur La Vigilante,
            dissimulant son identité pour prendre part à une expédition maritime dont elle mesure à peine
            les enjeux. Elle traverse alors le monde tel qu'on l'imaginait au XVIᵉ siècle : encore incertain,
            partiellement cartographié, semé de puissances rivales, de commerces clandestins, d'atlas convoités
            et de côtes que les Européens n'avaient pas fini de rêver.
          </p>
          <p>
            <strong>Tome I — Les routes secrètes de l'océan Indien</strong> emmène le lecteur sur les côtes
            africaines et malgaches, dans l'ombre des routes portugaises. <strong>Tome II — La Route de
            l'Est</strong> poursuit la traversée dans l'océan Indien, entre Sofala, Goa, Cochin, Malacca.
            <strong> Tome III — La Route du Soleil Levant</strong> conduit Malo jusqu'aux limites orientales
            du monde connu : le Japon, l'atlas, les rivalités européennes et un déplacement du regard.
          </p>
          <p>
            Ce cycle n'est pas seulement une aventure maritime. C'est le récit d'une transformation intérieure :
            comment une jeune personne, obligée de survivre dans un monde qui ne lui était pas destiné, apprend
            à lire les cartes, les silences et les mondes qu'elle traverse.
          </p>
        </>
      }
    />
  );
}
